class AddPlayButton {
  constructor(params) {
    this.events(params);
  }

  events(params) {
    const paramsArray = [].concat(params);
    paramsArray.forEach((p) => {
      this.addPlayButtonInit(p);
      this.markVideoAsPresentation(p);
    });
  }

  addPlayButtonInit({ targetSelector }) {
    const pauseText = "Pause";
    const playText = "Play";
    const buttonContainer = targetSelector;
    const containers = document.querySelectorAll(buttonContainer);

    if (!containers.length) return;

    containers.forEach((container) => {
      const videoPlayer = container.querySelector("video");
      if (videoPlayer) {
        const ppb = document.createElement("button");
        ppb.innerHTML = videoPlayer.paused ? playText : pauseText; // visible text
        ppb.setAttribute(
          "aria-label",
          videoPlayer.paused ? "Play Preview" : "Pause Preview",
        ); // screen reader text
        ppb.classList.add("pause-preview");

        ppb.addEventListener("click", function () {
          if (videoPlayer.paused) {
            videoPlayer.play();
            ppb.innerHTML = pauseText;
            ppb.classList
              .remove("paused")
              .setAttribute("aria-label", "Pause Preview");
          } else {
            videoPlayer.pause();
            ppb.innerHTML = playText;
            ppb.classList
              .add("paused")
              .setAttribute("aria-label", "Play Preview");
          }
        });

        container.appendChild(ppb);
      }
    });
  }
  markVideoAsPresentation({ targetSelector }) {
    const containers = document.querySelectorAll(targetSelector);
    containers.forEach((container) => {
      const video = container.querySelector("video");
      if (video) {
        video.setAttribute("aria-hidden", "true");
      }
    });
  }
}

export { AddPlayButton };
